import React from 'react';
import PropTypes from 'prop-types';
import useStyle from './style';

const LoadingBar = ({ color }) => {
  const classes = useStyle({ color });

  return (
    <div className={classes.loadingBar}>
      <div className="inside">
        <div className="inside" />
      </div>
    </div>
  );
};

LoadingBar.propTypes = {
  color: PropTypes.string,
};

LoadingBar.defaultProps = {
  color: 'primary',
};

export default LoadingBar;
